import { setDynatracePageName } from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
export const useDynatracePageName = (pageName) => {
    useEffectWithErrorLogging(() => {
        setDynatracePageName(pageName);
    }, []);
};
